import { Component, ElementRef, inject, Input, TemplateRef, ViewChild } from "@angular/core";
import { DialogRef, DialogService } from "@ngneat/dialog";
import { TranslateService } from "@ngx-translate/core";
import { PopupType } from "src/app/shared/enums/popup-types";
import { ContractService } from "src/app/shared/services/contract.service";
import { showMessage } from "src/app/shared/utils/toast.popup";

@Component({
  selector: "app-contract-db-import",
  templateUrl: "./contract-db-import.component.html",
  standalone: false,
})
export class ContractDbImportComponent {
  @Input() contractId!: number;
  @ViewChild("importModalTemplate") importModalTemplate!: TemplateRef<unknown>;
  @ViewChild("fileInput", { static: false }) fileInput!: ElementRef;
  file: File | null = null;
  loading = false;
  isLoadingUsers = false;
  activeTab = 1;
  users!: string[];
  selectedEmails: string[] = [];

  importModal!: DialogRef;
  private dialog = inject(DialogService);

  constructor(private contractService: ContractService, public translate: TranslateService) {}

  openImportModal(): void {
    this.file = null;
    this.activeTab = 1;
    this.importModal = this.dialog.open(this.importModalTemplate, {
      id: `dialog-${crypto.randomUUID()}`,
      size: "lg",
    });
  }

  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.file = input.files[0];
    }
  }

  loadDbUsers() {
    this.isLoadingUsers = true;
    const subscription = this.contractService.getContractDbUsers(this.contractId).subscribe((res) => {
      subscription.unsubscribe();
      this.isLoadingUsers = false;
      this.users = res;
      this.selectedEmails = res;
    });
  }

  handleImport(): void {
    if (this.file) {
      this.loading = true;
      const uploadSubscription = this.contractService.importDemoDatabase(this.contractId, this.file).subscribe({
        next: () => {
          uploadSubscription.unsubscribe();
          this.loading = false;
          this.activeTab = 2;
          this.loadDbUsers();
          showMessage(PopupType.Success, this.translate.instant("contract.import_successfull"));
        },
        error: (err) => {
          uploadSubscription.unsubscribe();
          this.loading = false;
          showMessage(PopupType.Danger, err.error);
        },
      });
    }
    else {
      showMessage(PopupType.Danger, this.translate.instant("contract.no_file_error"));
    }
  }

  handleMigrate(): void {
    this.loading = true;
    const subscription = this.contractService.migrateUsersApiKey(this.contractId, this.selectedEmails).subscribe({
      next: () => {
        subscription.unsubscribe();
        this.loading = false;
        this.importModal.close();
        showMessage(PopupType.Success, this.translate.instant("contract.migrate_successfull"));
      },
      error: (err) => {
        subscription.unsubscribe();
        this.loading = false;
        showMessage(PopupType.Danger, err.error);
      },
    });
  }

  toggleEmail(email: string, event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.checked) {
      if (!this.selectedEmails.includes(email)) {
        this.selectedEmails.push(email);
      }
    }
    else {
      this.selectedEmails = this.selectedEmails.filter(e => e !== email);
    }
  }
}
